import React from 'react';
import { Box } from '@chakra-ui/react';
import { useDynamicApiKeys } from '@hooks';
import { Code } from './code';
import lightTheme from 'prism-react-renderer/themes/github';
import { ToggleKeysVisibility } from '@components/common';

export function EnvSnippet({ body, theme, withCopy, withLineNumbers }: any) {
  const { showKeysVisibilityToggle, codeWithVisibleKeys, codeWithHiddenKeys } =
    useDynamicApiKeys(body.code);
  const [showKeys, setShowKeys] = React.useState(false);

  return (
    <Box my={4} pos="relative">
      <Code
        filename={body.filename || '.env'}
        theme={theme === 'light' ? lightTheme : theme}
        language={body.language}
        highlightedLines={body.highlightedLines}
        withLineNumbers={withLineNumbers}
        withCopy={withCopy}
        showKeysVisibilityToggle={showKeysVisibilityToggle}
        codeWithVisibleKeysFormatted={codeWithVisibleKeys}
        toggleComponent={
          <ToggleKeysVisibility showKeys={showKeys} setShowKeys={setShowKeys} />
        }
      >
        {showKeysVisibilityToggle
          ? showKeys
            ? codeWithVisibleKeys
            : codeWithHiddenKeys
          : codeWithVisibleKeys}
      </Code>
    </Box>
  );
}
